import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';

import './ChecklistTaskItemTag.less';

const ChecklistTaskItemTag = ({ children, color }) => (
  <div className={cx('task-item__tag', { [color]: color })}>
    {children}
  </div>
);

ChecklistTaskItemTag.propTypes = {
  color: PropTypes.oneOf(['green', 'orange', 'periwinkle']),
};

ChecklistTaskItemTag.defaultProps = {
  color: 'periwinkle',
};

export default ChecklistTaskItemTag;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskItem/ChecklistTaskItemTag/ChecklistTaskItemTag.jsx